<style lang="less" type="text/less" scoped>
    ._wrapper{
        position:fixed;
        bottom:0;
        left:0;
        right:0;
    }
    .bottom-inner{
        background:#fff;
        box-shadow: 0 0 40px rgba(0,0,0,0.2);
        height:45px;
        padding-top:5px;
    }
    .buttons{
        position:relative;
        .button{
            color:#666;
            width:40px;
            text-align:center;
            .iconfont{
                line-height:28px;

            }
            .title{
                font-size:12px;
                line-height:1em;
                margin:0 -20px;
            }
            &.active{
                color:#78a524;
            }
        }
        .button1{
            position:absolute;
            top:0;
            left:56px;
        }
        .button2{
            padding-top:1px;
            margin:0 auto;
            .icon-big-plus{
                position:relative;
                width:40px;
                height:40px;
                background:#fff;
                margin-top:-20px;
                border-radius:99px;
                @b:4px;
                margin-bottom:7px;
                box-shadow:0 -5px 15px -5px #0ee81f;
                .inner{
                    position:absolute;
                    top:@b;
                    left:@b;
                    width:40px - 2*@b;
                    height:40px - 2*@b;
                    background:#0ee81f;
                    border-radius:99px;
                    &:before,&:after{
                        content:'';
                        display:block;
                        height:16px;
                        width:3px;
                        background:#fff;
                        position:absolute;
                        top:50%;
                        left:50%;
                        border-radius:99px;
                        transform:translate(-50%,-50%);
                    }
                    &:after{
                        transform:translate(-50%,-50%) rotate(90deg);
                    }

                }
            }
        }
        .button3{
            position: absolute;
            top:0;
            right:56px;
        }
    }
</style>
<template>
    <div class="_wrapper">
        <div class="container bottom-inner">
            <div class="buttons">
                <div class="button button1" :class="{active:index===0}" @click="reloadIndex()">
                    <div class="iconfont icon-browser" ></div>
                    <div class="title">首页</div>
                </div>
                <div class="button button2" :class="{active:index===1}" @click="createPost">
                    <div class="icon-big-plus"><div class="inner"></div></div>
                    <div class="title">上传病例</div>
                </div>
                <div class="button button3" :class="{active:index===2}" @click="$router.push({name:'me'})">
                    <div class="iconfont icon-wode" ></div>
                    <div class="title">我的</div>
                </div>
            </div>
        </div>
        <div class="iphone-x-block"></div>
    </div>
</template>
<script type="text/ecmascript-6">
    import event from '../lib/event';
    export default {
        props:{
            index:true
        },
        data() {
            return {}
        },
        computed: {},
        methods: {
            reloadIndex(){
                this.$router.push({name:'index'})
            },
            createPost(){
                event.emit('create-post');
            }
        },
        components: {},
        mounted() {

        }
    }
</script>


// WEBPACK FOOTER //
// BottomBar.vue?01bdef72